var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('carousel-3d', {
    staticClass: "carousel",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    },
    on: {
      "after-slide-change": _vm.onSlideChange
    }
  }, _vm._l(_vm.itemList.items, function (slide, i) {
    return _c('slide', {
      key: i,
      attrs: {
        "index": i
      }
    }, [_c('flat-carousel-item', {
      attrs: {
        "allowHover": _vm.activeItem === i,
        "height": "height",
        "item": slide,
        "src": _vm.imageFix(slide.imageLinks.thumbnail)
      }
    })], 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }